import {
    SET_ASSET_MODAL_OPTIONS
  }
    from './actionTypes';

export function setAssetModalOptionAction(options){
    return function (dispatch){
        dispatch({
            type: SET_ASSET_MODAL_OPTIONS,
            payload : options
        })
    }
}